import React, { useContext, useState, useEffect } from "react";
import { get, isEmpty } from "lodash";
import { Row, Col, Form } from "react-bootstrap";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { faPencilAlt, faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { Formik, Field, FieldArray } from "formik";
import { useParams } from "react-router-dom";
import {
  ManagePlanLayout,
  FieldInput,
  FieldButtonGroup,
  DatePicker,
  FieldDropSide,
  FieldInputNumber,
  CsplTable as Table,
  MultiSelectDropdown,
  FieldTextarea,
  FieldInputDollar,
  FieldInputDecimal,
  FieldInputPercentage,
  DeleteWarning,
} from "../../../components";
import { useRouterParams, useRequest, useDeepEffect } from "../../../abstracts";
import {
  getPlanSourceInformation,
  getDefaultElectionSetting,
  getEmployeeClassification,
  saveAdditionalAutoEnrollment,
  getPlanInvestments,
  listSource,
  listInvestment,
} from "../../../services";
import {
  MANAGE_PLAN_ROUTES,
  managePlanFormNames,
  formFields,
  FLOW_TYPES,
  getAdvancedPathWithParam,
  yesNoOptions,
  returnOnlyIfBoolean,
  usDateFormat,
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
  toMultiSelectValueById,
  required,
  getPathWithParam,
  synchronizeCollectionPlanGroups,
  synchronizeCollectionNew,
} from "../../../utils";
import { useLocation } from "react-router-dom";
import {
  createPlanStore,
  setManagePlanToastInfo,
  setManagePlanFlow,
  setManagePageLevelData,
  setManagePlanLocalCache,
  savePlanDetailsAction,
} from "../../../contexts";
import ExcludedEmployeeClassficationFields from "../EnrollmentContainer/ExcludedEmployeeClassification";
import InvestmentElectionFields from "./InvestmentElection";
import { synchronizeCollectionInvestmentElectionBasedOnList } from "../EnrollmentContainer/EnrollmentContainer";

export const AdditionalAutoEnrollmentContainer = (props) => {
  //const { values, handleSubmit } = props;
  const { history } = props;
  const { state, dispatch } = useContext(createPlanStore);
  const [newFlow] = useState("");
  const { planId, flow, id, index } = useRouterParams();
  const formName = managePlanFormNames.ADD_ADDITIONAL_AUTO_ENROLLMENT;
  const fields = formFields[formName];
  const [toggle, setToggle] = useState(false);

  const [invetmentElectionError, setInvestmentElectionError] = useState({});

  const [
    excludedEmployeeClassifications,
    setExcludedEmployeeClassifications,
  ] = useState([]);
  const [excludedEmploymentStatuses, setExcludedEmploymentStatuses] = useState(
    []
  );
  const enrollmentCacheData = get(state, "AutoEnrollment", {});
  const apiData = get(state, "api.data", {});
  const enrollment = get(state, "AutoEnrollment", {});
  const [showWarning, setShowWarning] = useState(false);
  const DeleteToastMessage =
    "You are attempting to delete additional auto enrollment.";
  const DeleteToastMessageHead = "Delete Additional Auto Enrollment?";
  const getDefaultElection = !isEmpty(enrollmentCacheData)
    ? {
        planInvestment: get(enrollmentCacheData, "planInvestment", []),
        deferralSourceContribution: get(
          enrollmentCacheData,
          "deferralSourceContributions",
          []
        ),
      }
    : !isEmpty(enrollment)
    ? get(enrollment, "defaultElectionSetting", {})
    : Object.create(null);

  const autoEnrollment = get(enrollment, "autoEnrollment", []);
  const additionalAutoEnrollment = isEmpty(
    get(state, "AdditionalAutoEnrollment")
  )
    ? get(autoEnrollment, "additionalAutoEnrollment", [])
    : get(state, "AdditionalAutoEnrollment", []);
  const AdditionalAutoEnrollmentData = isEmpty(
    get(state, "AdditionalAutoEnrollment", [])
  )
    ? !isEmpty(additionalAutoEnrollment)
      ? additionalAutoEnrollment
      : []
    : get(state, "AdditionalAutoEnrollment", []);

  const [sourcesList, setSourceList] = useState([]);
  const [investmentList, setInvestmentList] = useState([]);

  useEffect(() => {
    if (isEmpty(state?.listSource))
      listSource(parseInt(planId))
        .then((response) => {
          setSourceList(response.employerSourcesList);
          dispatch(
            setManagePlanLocalCache({
              model: "listSource",
              data: response,
            })
          );
        })
        .catch((error) => {});
    else setSourceList(state?.listSource?.employerSourcesList);
    if (isEmpty(state?.listInvestment))
      listInvestment(parseInt(planId))
        .then((response) => {
          setInvestmentList(response.investmentPlanMappings);
          dispatch(
            setManagePlanLocalCache({
              model: "listInvestment",
              data: response,
            })
          );
        })
        .catch((error) => {
          //Handle Error
        });
    else setInvestmentList(state?.listInvestment?.investmentPlanMappings);
  });
  const deferralSourcesList = sourcesList.filter(
    (source) => source.sourceType === 1 && source.sourceCategory === 2
  );

  const transformedDeferralSourceList = !isEmpty(deferralSourcesList)
    ? deferralSourcesList.map((e) => ({
        sourceId: e.id,
        sourceName: e.sourceName,
        contributionType: get(e, "employeeDeferralSource.contributionType"),
        maximumRate: e.employeeDeferralSource.limitMaximumDollar,
        minimumRate: e.employeeDeferralSource.limitMinimumDollar,
        contributionRate: null,
      }))
    : [];

  const search = useLocation().search;
  const Id = new URLSearchParams(search).get("id");
  // const formValues = get(additionalAutoEnrollment, Id, {});
  const findAddAutoEnroll = additionalAutoEnrollment.find((_, ind) => {
    return parseInt(id) !== 0 ? _.id == parseInt(id) : ind == parseInt(index);
  });
  const formValues = !isEmpty(findAddAutoEnroll) ? findAddAutoEnroll : {};

  useEffect(() => {
    getEmployeeClassification(planId).then((response) => {
      setExcludedEmployeeClassifications(
        response.employeeClassifications &&
          response.employeeClassifications.map((val, ind) => ({
            label: val.codeName + val.code,
            value: val.code,
          }))
      );
      setExcludedEmploymentStatuses(
        response.employmentStatuses &&
          response.employmentStatuses.map((val, ind) => ({
            label: val.employmentStatusName + val.employmentStatusCode,
            value: val.employmentStatusCode,
          }))
      );
    });
  }, []);
  const initialValues = {
    id: 0,
    additionalAutoEnrollmentInvestmentElectionBasedOnList: [
      {
        investmentBasedOn: 1,
        ageFrom: null,
        ageTo: null,
        from: null,
        to: null,
      },
    ],
    additionalAutoEnrollmentDeferralSources: [
      {
        id: 0,
        deferralSourceName: null,
        limitMaximumDollar: 0,
        limitMinimumDollar: 0,
      },
    ],
    additionalAutoEnrollmentInvestmentElection: [
      {
        investmentName: null,
      },
    ],
    additionalAutoEnrollmentSouceInvestmentElections: [
      [
        //investmentElection=
        {
          investmentName: null,
        },
      ],
    ],
    additionalAutoEnrollmentCategorywiseInvestment: [
      [
        {
          investmentName: null,
        },
      ],
    ],
    additionalAutoEnrollmentDifferentInvestmentElection: [
      [
        [
          {
            investmentName: null,
          },
        ],
      ],
    ],
    [fields.usePlanDefaultDeferralElection]: true,
    [fields.usePlanDefaultInvestmentElection]: true,
    [fields.exclusionType]: 0,
  };
  const handleCancelClick = () => {
    setShowWarning(false);
  };
  const deleteAdditionalAutoEnrollment = () => {
    dispatch(
      setManagePlanLocalCache({
        model: "AdditionalAutoEnrollment",
        data: [
          ...AdditionalAutoEnrollmentData.filter(
            (_, ind_) => ind_ !== parseInt(index)
          ),
        ],
      })
    );
    dispatch(
      setManagePlanLocalCache({
        model: "AutoEnrollment",
        data: {
          ...get(state, "AutoEnrollment", {}),
          tabOpenInAutoEnrollment: 3,
        },
      })
    );
    dispatch(
      setManagePlanLocalCache({
        model: "api",
        data: {
          ...get(state, "api", {}),
          data: {
            ...get(state, "api.data", {}),
            enrollment: {
              ...get(state, "api.data.enrollment", {}),
              autoEnrollment: {
                ...get(state, "api.data.enrollment.autoEnrollment", {}),
                additionalAutoEnrollment: get(
                  state,
                  "api.data.enrollment.autoEnrollment.additionalAutoEnrollment",
                  []
                ).filter((_) => _.id !== parseInt(id)),
              },
            },
          },
        },
      })
    );
    dispatch(
      setManagePlanToastInfo({
        showToast: true,
        toastMessage: `Data deleted successfully`,
      })
    );

    history.push(
      getAdvancedPathWithParam({
        path: MANAGE_PLAN_ROUTES.ENROLLMENT,
        pathParam: [FLOW_TYPES.SAVE, planId],
      })
    );
  };

  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
      onClick: () => {
        dispatch(
          setManagePlanLocalCache({
            model: "AutoEnrollment",
            data: {
              ...get(state, "AutoEnrollment", {}),
              tabOpenInAutoEnrollment: 3,
              isDirty: true,
            },
          })
        );
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_PLAN_ROUTES.ENROLLMENT,
            pathParam: [FLOW_TYPES.SAVE, planId],
          })
        );
      },
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD],
    },
    {
      label: "Edit",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_PLAN_ROUTES.ADDITIONAL_AUTO_ENROLLMENT,
            pathParam: [FLOW_TYPES.SAVE, planId, id, index],
          })
        ),
    },
    {
      label: "Delete",
      variant: "danger",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      //icon: faTrashAlt,
      onClick: () => setShowWarning(true),
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.SAVE],
    },
  ];
  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = newFlow === FLOW_TYPES.SAVE;
  const displayType = (amt, cont, number) => {
    let res;
    if (cont === "Dollar")
      res =
        number === 0
          ? "Minimum amount " + "$" + amt
          : "Maximum amount " + "$" + amt;
    else
      res =
        number === 0
          ? "Minimum percentage " + amt + "%"
          : "Maximum percentage " + amt + "%";
    return res;
  };

  const getInitialValues = (autoEnrollment) => {
    if (isEmpty(autoEnrollment)) return {};
    const values = [
      ...get(
        autoEnrollment,
        "additionalAutoEnrollmentInvestmentElectionBasedOnList",
        null
      ).filter((_) => _.isDefaultCategory),
      ...get(
        autoEnrollment,
        "additionalAutoEnrollmentInvestmentElectionBasedOnList",
        null
      ).filter((_) => !_.isDefaultCategory),
    ];
    const doubleDArrayOfValues = values.map((_) =>
      get(_, "additionalAutoEnrollmentInvestmentElectionValuesList", []).map(
        (x) => {
          return {
            ...x,
            ageFrom: _.ageFrom,
            ageTo: _.ageTo,
            from: _.from,
            to: _.to,
            investmentName: get(
              investmentList?.filter((y) => y.id === x.investmentId),
              `${0}.name`,
              null
            ),
            sourceName: get(
              sourcesList?.filter((y) => y.id === x.sourceId),
              `${0}.sourceName`,
              null
            ),
          };
        }
      )
    );
    let singleDArrayOfValues = [];
    for (let i = 0; i < doubleDArrayOfValues.length; i++) {
      singleDArrayOfValues = singleDArrayOfValues.concat(
        doubleDArrayOfValues[i]
      );
    }
    singleDArrayOfValues = singleDArrayOfValues.sort(
      (a, b) => a.investmentId - b.investmentId
    );
    /////////////// For getting investment added value from backend ////////////////
    let initialSavedInvestments = [];
    if (get(autoEnrollment, "sameInvestmentElectiontoAllSources") === true) {
      initialSavedInvestments = investmentList?.filter((inv) => {
        return singleDArrayOfValues.map((y) => y.investmentId).includes(inv.id);
      });
    } else if (
      get(autoEnrollment, "sameInvestmentElectiontoAllSources") === false
    ) {
      for (let i in sourcesList) {
        initialSavedInvestments.push(
          investmentList?.filter((inv) => {
            return singleDArrayOfValues
              .filter((_) => _.sourceId === sourcesList[i].id)
              .map((y) => y.investmentId)
              .includes(inv.id);
          })
        );
      }
    }
    if (
      get(autoEnrollment, "sameDefaultInvestmentToAllParticipants") === false
    ) {
      initialSavedInvestments = {
        [autoEnrollment.investmentBasedOn]: initialSavedInvestments,
      };
    }
    //////////////////////////////////////////////////////////////////////////////////
    const additionalAutoEnrollmentInvestmentElectionBasedOnList = values.map(
      (_) => {
        return {
          id: _.id,
          ageFrom: _.ageFrom,
          ageTo: _.ageTo,
          autoEnrollmentId: _.autoEnrollmentId,
          from: _.from,
          investmentBasedOn: _.investmentBasedOn,
          to: _.to,
          isDefaultCategory: _.isDefaultCategory,
        };
      }
    );

    let additionalAutoEnrollmentInvestmentElection = [];
    let additionalAutoEnrollmentSourceInvestmentElection = [];
    let additionalAutoEnrollmentCategorywiseInvestment = [];
    let additionalAutoEnrollmentDifferentInvestmentElection = [];
    if (
      get(autoEnrollment, "sameDefaultInvestmentToAllParticipants") === true
    ) {
      //same for all source , same for all participants
      if (get(autoEnrollment, "sameInvestmentElectiontoAllSources") === true) {
        additionalAutoEnrollmentInvestmentElection = singleDArrayOfValues;
      }
      //diff source same participant
      else if (
        get(autoEnrollment, "sameInvestmentElectiontoAllSources") === false
      ) {
        for (let i in sourcesList) {
          const temp = singleDArrayOfValues.filter(
            (_) => _.sourceId === sourcesList[i].id
          );
          additionalAutoEnrollmentSourceInvestmentElection.push(temp);
        }
      }
    }
    // different participant
    else if (
      get(autoEnrollment, "sameDefaultInvestmentToAllParticipants") === false
    ) {
      //same source diff participant
      if (get(autoEnrollment, "sameInvestmentElectiontoAllSources") === true) {
        let classificationGroup = [];
        for (let j in values) {
          const investmentGroup = singleDArrayOfValues.filter((_) => {
            if (
              _.additionalAutoEnrollmentInvestmentElectionBasedOnId ===
              values[j].id
            ) {
              return true;
            }
            return false;
          });
          additionalAutoEnrollmentCategorywiseInvestment.push(investmentGroup);
        }
        // additionalAutoEnrollmentCategorywiseInvestment.push(classificationGroup);
      }
      //diff source diff participant
      else if (
        get(autoEnrollment, "sameInvestmentElectiontoAllSources") === false
      ) {
        for (let i in sourcesList) {
          let classificationGroup = [];
          for (let j in values) {
            let investmentGroup = singleDArrayOfValues.filter((_) => {
              if (
                _.sourceId === sourcesList[i].id &&
                _.additionalAutoEnrollmentInvestmentElectionBasedOnId ===
                  values[j].id
              ) {
                return true;
              }
              return false;
            });
            // investmentGroup.sort((a,b) => a.investmentId > b.investmentId ? 1: 0);
            classificationGroup.push(investmentGroup);
          }
          additionalAutoEnrollmentDifferentInvestmentElection.push(
            classificationGroup
          );
        }
      }
    }
    return {
      ...autoEnrollment,
      sameInvestmentElectionToAllSources:
        autoEnrollment.sameInvestmentElectiontoAllSources,
      sameInvestmentElectionToAllParticipants:
        autoEnrollment.sameDefaultInvestmentToAllParticipants,
      additionalAutoEnrollmentInvestmentElection: additionalAutoEnrollmentInvestmentElection,
      additionalAutoEnrollmentSourceInvestmentElection: additionalAutoEnrollmentSourceInvestmentElection,
      additionalAutoEnrollmentCategorywiseInvestment: additionalAutoEnrollmentCategorywiseInvestment,
      additionalAutoEnrollmentDifferentInvestmentElection: additionalAutoEnrollmentDifferentInvestmentElection,
      additionalAutoEnrollmentInvestmentElectionBasedOnList: additionalAutoEnrollmentInvestmentElectionBasedOnList,
      initialSavedInvestments: initialSavedInvestments,
    };
  };

  const convertAutoEnrollmentValuesOnSubmit = (Avalues) => {
    let investmentElectionBasedOnList = [];
    let additionalAutoEnrollmentInvestmentElectionMap = [];
    //for same source and same participants

    if (
      get(Avalues, "sameInvestmentElectionToAllParticipants", null) === true &&
      get(Avalues, "sameInvestmentElectionToAllSources", null) === true
    ) {
      additionalAutoEnrollmentInvestmentElectionMap = Avalues.additionalAutoEnrollmentInvestmentElection.map(
        (_, ind) => {
          return {
            ..._,
            additionalAutoEnrollmentId: get(
              additionalAutoEnrollment,
              "0.autoEnrollmentId",
              0
            ),
            sourceId: null,
            additionalAutoEnrollmentInvestmentElectionBasedOnId: get(
              _,
              "investmentElectionBasedOnId",
              0
            ),
          };
        }
      );
    }
    //for diff source and same participants
    let additionalAutoEnrollmentSourceInvestmentElectionList = [];
    if (
      get(Avalues, "sameInvestmentElectionToAllParticipants", null) === true &&
      get(Avalues, "sameInvestmentElectionToAllSources", null) === false
    ) {
      for (let i in Avalues.additionalAutoEnrollmentSourceInvestmentElection) {
        // let sourceIdOfI = sourcesList[i].sourceId;
        for (let j in Avalues.additionalAutoEnrollmentSourceInvestmentElection[
          i
        ]) {
          additionalAutoEnrollmentSourceInvestmentElectionList.push({
            additionalAutoEnrollmentId: get(
              additionalAutoEnrollment,
              "0.autoEnrollmentId",
              0
            ),
            sourceId:
              Avalues.additionalAutoEnrollmentSourceInvestmentElection[i][j]
                .sourceId,
            additionalAutoEnrollmentInvestmentElectionBasedOnId: get(
              Avalues.additionalAutoEnrollmentSourceInvestmentElection[i][j],
              "investmentElectionBasedOnId",
              0
            ),
            investmentId:
              Avalues.additionalAutoEnrollmentSourceInvestmentElection[i][j]
                .investmentId,
            investmentPercentage:
              Avalues.additionalAutoEnrollmentSourceInvestmentElection[i][j]
                .investmentPercentage,
          });
        }
      }
    }
    //for diff participants
    let differentInvestmentElectionList = [];
    if (
      get(Avalues, "sameInvestmentElectionToAllParticipants", null) === false
    ) {
      const differentInvestmentElection =
        Avalues.sameInvestmentElectionToAllSources === false
          ? Avalues.additionalAutoEnrollmentDifferentInvestmentElection
          : [Avalues.additionalAutoEnrollmentCategorywiseInvestment];
      for (let i in differentInvestmentElection) {
        // let sourceIdOfI = Avalues.sameInvestmentElectionToAllSources ? null : sourcesList[i].sourceId;
        for (let j in differentInvestmentElection[i]) {
          // let investmentElectionBasedOnId = j;
          for (let k in differentInvestmentElection[i][j]) {
            differentInvestmentElectionList.push({
              additionalAutoEnrollmentId: get(
                additionalAutoEnrollment,
                "0.autoEnrollmentId",
                0
              ),
              sourceId: get(
                differentInvestmentElection[i][j][k],
                "sourceId",
                null
              ),
              additionalAutoEnrollmentInvestmentElectionBasedOnId: get(
                differentInvestmentElection[i][j][k],
                "investmentElectionBasedOnId",
                0
              ),
              investmentElectionBasedOnIndex: j,
              investmentId: differentInvestmentElection[i][j][k].investmentId,
              investmentPercentage:
                differentInvestmentElection[i][j][k].investmentPercentage,
            });
          }
        }
      }
    }
    if (Avalues[fields.usePlanDefaultInvestmentElection]) {
      investmentElectionBasedOnList.push({
        // id: get(enrollment, "autoEnrollment.sameInvestmentElectionToAllParticipants", false) ? get(enrollment, "autoEnrollment.investmentElectionBasedOnList.0.id", 0) : 0,
        ageFrom: null,
        ageTo: null,
        additionalAutoEnrollmentId: get(
          additionalAutoEnrollment,
          "0.autoEnrollmentId",
          0
        ),
        from: null,
        investmentBasedOn: null,
        to: null,
        additionalAutoEnrollmentInvestmentElectionValuesList: get(
          getDefaultElection,
          "planInvestment",
          []
        ).map((_) => {
          return {
            additionalAutoEnrollmentInvestmentElectionBasedOnId: formValues[
              fields.usePlanDefaultInvestmentElection
            ]
              ? get(
                  formValues,
                  "additionalAutoEnrollmentInvestmentElectionValuesList.0.id",
                  0
                )
              : 0,
            additionalAutoEnrollmentId: get(enrollment, "autoEnrollment.id", 0),
            investmentName: _.investmentName,
            investmentId: _.investmentId,
            investmentPercentage: _.investmentPercentage,
            sourceId: null,
            // sourceName: "",
          };
        }),
      });
    }
    //this is for adding the investmentElectionValues array to the investmentElectionBasedOn entries
    if (Avalues.sameInvestmentElectionToAllParticipants === true) {
      investmentElectionBasedOnList.push({
        // id: get(enrollment, "autoEnrollment.sameInvestmentElectionToAllParticipants", false) ? get(enrollment, "autoEnrollment.investmentElectionBasedOnList.0.id", 0) : 0,
        ageFrom: null,
        ageTo: null,
        additionalAutoEnrollmentId: get(
          additionalAutoEnrollment,
          "0.autoEnrollmentId",
          0
        ),
        from: null,
        investmentBasedOn: null,
        to: null,
        additionalAutoEnrollmentInvestmentElectionValuesList: Avalues.sameInvestmentElectionToAllSources
          ? additionalAutoEnrollmentInvestmentElectionMap
          : additionalAutoEnrollmentSourceInvestmentElectionList,
      });
    } else if (Avalues.sameInvestmentElectionToAllParticipants === false) {
      for (let i in Avalues.additionalAutoEnrollmentInvestmentElectionBasedOnList) {
        const isDefaultCategoryFlag = get(
          Avalues.additionalAutoEnrollmentInvestmentElectionBasedOnList[i],
          "isDefaultCategory",
          false
        );
        const doesInvestmentElectionBasedOnListConatinsDefault =
          Avalues.additionalAutoEnrollmentInvestmentElectionBasedOnList.filter(
            (_) => _.isDefaultCategory
          ).length !== 0;
        investmentElectionBasedOnList.push({
          ...Avalues.additionalAutoEnrollmentInvestmentElectionBasedOnList[i],
          additionalAutoEnrollmentId: get(
            additionalAutoEnrollment,
            "0.autoEnrollmentId",
            0
          ),
          additionalAutoEnrollmentInvestmentElectionValuesList: differentInvestmentElectionList.filter(
            (_) =>
              (isDefaultCategoryFlag &&
                parseInt(_.investmentElectionBasedOnIndex) == 0) ||
              (!(isDefaultCategoryFlag == true) &&
                parseInt(_.investmentElectionBasedOnIndex) ==
                  parseInt(
                    doesInvestmentElectionBasedOnListConatinsDefault ? i : i + 1
                  ))
          ),
        });
      }
      //for default option
      if (
        !investmentElectionBasedOnList
          .map((_) => _.isDefaultCategory)
          .includes(true)
      ) {
        investmentElectionBasedOnList.push({
          isDefaultCategory: true,
          additionalAutoEnrollmentId: get(
            additionalAutoEnrollment,
            "0.autoEnrollmentId",
            0
          ),
          additionalAutoEnrollmentInvestmentElectionValuesList: differentInvestmentElectionList.filter(
            (_) => parseInt(_.investmentElectionBasedOnIndex) == 0
          ),
        });
      }
    }

    return investmentElectionBasedOnList;
  };

  const preData = (values) => {
    const {
      additionalAutoEnrollmentInvestmentElection,
      additionalAutoEnrollmentDifferentInvestmentElection,
      additionalAutoEnrollmentSourceInvestmentElection,
      additionalAutoEnrollmentCategorywiseInvestment,
      additionalAutoEnrollmentInvestmentElectionBasedOnList,
      ...filteredValues
    } = values;
    const excEmployeeStatus = !isEmpty(
      get(values, "excludedEmploymentStatuses", [])
    )
      ? (get(values, "excludedEmploymentStatuses") ?? []).map((e) => {
          const selected = excludedEmploymentStatuses.find(
            (f) => (e = f.value)
          );
          return {
            label: selected.label,
            employmentStatusCode: selected.value,
          };
        })
      : [];
    const excEmployeeClassifications = !isEmpty(
      get(values, "excludedEmployeeClassifications", [])
    )
      ? (get(values, "excludedEmployeeClassifications") ?? []).map((e) => {
          const selected = excludedEmployeeClassifications.find(
            (f) => (e = f.value)
          );
          return {
            label: selected.label,
            code: selected.value,
          };
        })
      : [];
    return {
      ...filteredValues,
      sameInvestmentElectiontoAllSources:
        filteredValues.sameInvestmentElectionToAllSources,
      sameDefaultInvestmentToAllParticipants:
        filteredValues.sameInvestmentElectionToAllParticipants,
      additionalAutoEnrollmentDeferralSources: synchronizeCollectionNew(
        get(formValues, "additionalAutoEnrollmentDeferralSources", []) ?? [],
        get(values, "additionalAutoEnrollmentDeferralSources", []) ?? [],
        "id"
      ),
      excludedEmployeeClassifications: synchronizeCollectionNew(
        get(formValues, "excludedEmployeeClassifications", []) ?? [],
        excEmployeeClassifications,
        "id"
      ),
      excludedEmploymentStatuses: synchronizeCollectionNew(
        get(formValues, "excludedEmploymentStatuses") ?? [],
        excEmployeeStatus,
        "id"
      ),
      additionalAutoEnrollmentInvestmentElectionBasedOnList: synchronizeCollectionInvestmentElectionBasedOnList(
        get(
          formValues,
          "additionalAutoEnrollmentInvestmentElectionBasedOnList"
        ) ?? [],
        convertAutoEnrollmentValuesOnSubmit(values) ?? [],
        true
      ),
    };
  };

  const onFormSubmit = (values, { setFieldError }) => {
    const {
      additionalAutoEnrollmentInvestmentElection,
      additionalAutoEnrollmentDifferentInvestmentElection,
      additionalAutoEnrollmentSourceInvestmentElection,
      additionalAutoEnrollmentCategorywiseInvestment,
      additionalAutoEnrollmentInvestmentElectionBasedOnList,
      ...filteredValues
    } = values;
    // savePlanDetailsAction(
    //   {
    //     enrollment: {
    //       ...enrollment,
    //       autoEnrollment:{
    //         ...autoEnrollment,
    //         additionalAutoEnrollment:[
    //           // ...additionalAutoEnrollment,
    //         {
    //           ...preData(filteredValues),
    //           additionalAutoEnrollmentInvestmentElectionBasedOnList: convertAutoEnrollmentValuesOnSubmit(values),
    //         }
    //         ]
    //       }
    //     }
    //   },
    //   dispatch,
    //   state
    // )
    let errorMsg = null;
    if (values.sameInvestmentElectionToAllParticipants === false) {
      if (values.investmentBasedOn === 1) {
        let ageList = [];
        for (
          let i = 0;
          i < additionalAutoEnrollmentInvestmentElectionBasedOnList.length;
          i++
        ) {
          const fromAge = parseInt(
            additionalAutoEnrollmentInvestmentElectionBasedOnList[i].ageFrom
          );
          const toAge = parseInt(
            additionalAutoEnrollmentInvestmentElectionBasedOnList[i].ageTo
          );
          if (ageList.length > 0 && ageList[ageList.length - 1] >= fromAge) {
            setFieldError(
              `age.${i}.from`,
              "PL830 : Age groups should not overlap"
            );
          }
          ageList.push(fromAge);
          ageList.push(toAge);
        }
      } else {
        let dateList = [];
        for (
          let i = 0;
          i < additionalAutoEnrollmentInvestmentElectionBasedOnList.length;
          i++
        ) {
          const fromDate =
            additionalAutoEnrollmentInvestmentElectionBasedOnList[i].from;
          const toDate =
            additionalAutoEnrollmentInvestmentElectionBasedOnList[i].to;
          if (
            dateList.length > 0 &&
            dateList[dateList.length - 1] >= fromDate
          ) {
            setFieldError(
              `${
                values.investmentBasedOn === 2 ? "birthDate" : "retirement"
              }.${i}.from`,
              "PL834 : Date ranges should not overlap"
            );
          }
          dateList.push(fromDate);
          dateList.push(toDate);
        }
      }
    }

    if (
      values.sameInvestmentElectionToAllParticipants === true &&
      values.sameInvestmentElectionToAllSources === true &&
      get(
        values,
        "additionalAutoEnrollmentInvestmentElection",
        []
      ).filter((_) => get(_, "investmentName")).length === 0
    ) {
      setInvestmentElectionError({
        investmentElectionSameSourceSameParticipant: "PL821 : Required",
      });
      errorMsg = "PL821 : Required";
    } else if (
      values.sameInvestmentElectionToAllParticipants === false &&
      values.sameInvestmentElectionToAllSources === true &&
      get(
        values,
        "additionalAutoEnrollmentCategorywiseInvestment.0",
        []
      ).filter((_) => get(_, "investmentName")).length === 0
    ) {
      setInvestmentElectionError({
        investmentElectionSameSourceDiffParticipant: "PL822 : Required",
      });
      errorMsg = "PL822 : Required";
    } else if (
      values.sameInvestmentElectionToAllParticipants === true &&
      values.sameInvestmentElectionToAllSources === false &&
      get(
        values,
        "additionalAutoEnrollmentSourceInvestmentElection",
        []
      ).filter((_) => get(_, "0.investmentName")).length !== sourcesList.length
    ) {
      setInvestmentElectionError({
        investmentElectionDiffSourceSameParticipant: "PL823 : Required",
      });
      errorMsg = "PL823 : Required";
    } else if (
      values.sameInvestmentElectionToAllParticipants === false &&
      values.sameInvestmentElectionToAllSources === false &&
      get(
        values,
        "additionalAutoEnrollmentDifferentInvestmentElection",
        []
      ).filter((_) => !isEmpty(_) && get(_, "0.0.investmentName")).length !==
        sourcesList.length
    ) {
      setInvestmentElectionError({
        investmentElectionDiffSourceDiffParticipant: "PL824 : Required",
      });
      errorMsg = "PL824 : Required";
    } else {
      setInvestmentElectionError({});
    }

    if (errorMsg === null) {
      dispatch(
        setManagePlanLocalCache({
          model: "AdditionalAutoEnrollment",
          data: [
            ...AdditionalAutoEnrollmentData.filter((_, ind) =>
              _.id == 0 ? ind !== parseInt(index) : _.id !== values.id
            ),
            preData(values),
          ],
          // data: [{...preData(values)}],
        })
      );
      dispatch(
        setManagePlanLocalCache({
          model: "AutoEnrollment",
          data: {
            ...get(state, "AutoEnrollment", {}),
            tabOpenInAutoEnrollment: 3,
            isDirty: true,
          },
        })
      );
      history.push(
        getPathWithParam({
          path: MANAGE_PLAN_ROUTES.ENROLLMENT,
          pathParam: [FLOW_TYPES.SAVE, planId],
        })
      );
    }
  };
  return (
    <Formik
      initialValues={{
        ...initialValues,
        ...getInitialValues(formValues),
        [fields.excludedEmploymentStatuses]: isEmpty(
          formValues.excludedEmploymentStatuses
        )
          ? null
          : formValues.excludedEmploymentStatuses?.map(
              (val, ind) => val.employmentStatusCode
            ),
        [fields.excludedEmployeeClassifications]: isEmpty(
          get(formValues, "excludedEmployeeClassifications")
        )
          ? null
          : get(formValues, "excludedEmployeeClassifications").map(
              (val, ind) => val.code
            ),
      }}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {(formProps) => {
        const {
          handleChange,
          setFieldValue,
          handleSubmit,
          setValues,
          setTouched,
          values,
          setSubmitting,
          ...rest
        } = formProps;
        const onDaySelected = (fieldName, value) => {
          setFieldValue(fieldName, value);
        };
        const selectedexcludedEmploymentStatuses =
          values[fields.excludedEmploymentStatuses];
        const selectedExcludedEmployeeClassifications =
          values[fields.excludedEmployeeClassifications];

        const onExclusionTypeChange = (value) => {
          if (value !== values[fields.exclusionType]) {
            value !== 2 &&
              setFieldValue(fields.excludedEmployeeClassifications, null);
            value !== 3 &&
              setFieldValue(fields.excludedEmployeeClassifications, null);
            setFieldValue(fields.dateOfHire, null);
            setFieldValue(fields.hiredOnOrAfterDateAdditionalEnrollment, null);
            setFieldValue(fields.hiredOnOrBeforeDateAdditionalEnrollment, null);
            setFieldValue(fields.hiredBetweenFrom, null);
            setFieldValue(fields.hiredBetweenTo, null);
            value !== 1 && setFieldValue(fields.dateOfHire, null);
            setFieldValue(fields.hiredOnOrAfterDateAdditionalEnrollment, null);
            setFieldValue(fields.hiredOnOrBeforeDateAdditionalEnrollment, null);
            setFieldValue(fields.hiredBetweenFrom, null);
            setFieldValue(fields.hiredBetweenTo, null);
          }
        };

        const onDateOfHireChange = (value) => {
          if (value !== values[fields.dateOfHire]) {
            value !== 1 &&
              setFieldValue(
                fields.hiredOnOrAfterDateAdditionalEnrollment,
                null
              );
            value !== 2 &&
              setFieldValue(
                fields.hiredOnOrBeforeDateAdditionalEnrollment,
                null
              );
            value !== 3 && setFieldValue(fields.hiredBetweenFrom, null);
            setFieldValue(fields.hiredBetweenTo, null);
          }
        };

        return (
          <Form
            autoComplete="off"
            className="h-100"
            onSubmit={handleSubmit}
            //validated={!isEmpty(rest.errors)}
          >
            <ManagePlanLayout buttons={buttons} pageFlow={newFlow || flow}>
              <div className="d-flex flex-column">
                <Field
                  name={fields.enrollmentDescription}
                  label="Enrollment description"
                  autoComplete="off"
                  value={values[fields.enrollmentDescription]}
                  onChange={handleChange}
                  component={FieldTextarea}
                  disabled={isEdit && !isSave}
                  isRequired
                  size="md"
                  // maxlength="50"
                  validate={(value) => {
                    return [undefined, null, ""].includes(value) ||
                      value.trim().length === 0
                      ? "PL800 : Required"
                      : values[fields.enrollmentDescription].trim().length > 50
                      ? "PL850 :Enrollment description length should not Exceed 50 characters"
                      : undefined;
                  }}
                />

                <Field
                  label="Enrollment effective Start Date"
                  name={fields.enrollmentEffectiveStartDate}
                  isDatePicker
                  size="md"
                  value={usDateFormat(
                    values[fields.enrollmentEffectiveStartDate]
                  )}
                  selectedValue={values[fields.enrollmentEffectiveStartDate]}
                  component={FieldDropSide}
                  isRequired
                  onClear={() =>
                    setFieldValue(fields.enrollmentEffectiveStartDate, "")
                  }
                  disabled={isEdit && !isSave}
                  validate={(value) => {
                    return [undefined, null, ""].includes(value)
                      ? "PL801 : Required"
                      : undefined;
                  }}
                  popupContent={
                    <DatePicker
                      onDayClick={(value) =>
                        onDaySelected(
                          fields.enrollmentEffectiveStartDate,
                          value
                        )
                      }
                      value={usDateFormat(
                        values[fields.enrollmentEffectiveStartDate]
                      )}
                    />
                  }
                />
                <Field
                  label="Enrollment effective End Date"
                  name={fields.enrollmentEffectiveEndDate}
                  isDatePicker
                  isRequired
                  value={usDateFormat(
                    values[fields.enrollmentEffectiveEndDate]
                  )}
                  selectedValue={values[fields.enrollmentEffectiveEndDate]}
                  component={FieldDropSide}
                  onClear={() =>
                    setFieldValue(fields.enrollmentEffectiveEndDate, "")
                  }
                  disabled={isEdit && !isSave}
                  popupContent={
                    <DatePicker
                      onDayClick={(value) =>
                        onDaySelected(fields.enrollmentEffectiveEndDate, value)
                      }
                      value={usDateFormat(
                        values[fields.enrollmentEffectiveEndDate]
                      )}
                    />
                  }
                  validate={(value) => {
                    return [undefined, null, ""].includes(
                      values[fields.enrollmentEffectiveEndDate]
                    )
                      ? "PL802 : Required"
                      : values[fields.enrollmentEffectiveStartDate] >
                        values[fields.enrollmentEffectiveEndDate]
                      ? "PL819 : Effective start date must be before effective end date"
                      : usDateFormat(
                          values[fields.enrollmentEffectiveStartDate]
                        ) ===
                        usDateFormat(values[fields.enrollmentEffectiveEndDate])
                      ? "PL820 : Effective start date cannot be same as effective end date"
                      : undefined;
                  }}
                />

                <Field
                  isRequired
                  label="Additional Enrollment Options"
                  name={fields.exclusionType}
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.ADDITIONAL_AUTO_ENROLLMENT_OPTIONS
                  )}
                  value={values[fields.exclusionType]}
                  selectedValue={values[fields.exclusionType]}
                  component={FieldButtonGroup}
                  onChange={(value) => {
                    setFieldValue(fields.exclusionType, value);
                    onExclusionTypeChange(value);
                  }}
                  validate={(value) => {
                    return [undefined, null, ""].includes(value)
                      ? "PL802 : Required"
                      : undefined;
                  }}
                  disabled={isEdit && !isSave}
                  size="smd"
                />
                {values[fields.exclusionType] === 2 ? (
                  <>
                    <Field
                      size="md"
                      isRequired
                      label="Employee Classifications"
                      options={excludedEmployeeClassifications}
                      name={fields.excludedEmployeeClassifications}
                      value={toMultiSelectValueById(
                        selectedExcludedEmployeeClassifications,
                        excludedEmployeeClassifications
                      )}
                      disabled={isEdit && !isSave}
                      isMultiSelect
                      popupContent={
                        <MultiSelectDropdown
                          label="Select an Employee Classifications"
                          options={excludedEmployeeClassifications}
                          onSelect={(value) =>
                            setFieldValue(
                              fields.excludedEmployeeClassifications,
                              value
                            )
                          }
                          name={fields.excludedEmployeeClassifications}
                          value={values[fields.excludedEmployeeClassifications]}
                          disabled={isEdit && !isSave}
                        />
                      }
                      validate={(value) => {
                        return [undefined, null, ""].includes(value)
                          ? "PL803 : Required"
                          : undefined;
                      }}
                      component={FieldDropSide}
                    />
                  </>
                ) : null}

                {values[fields.exclusionType] === 1 ? (
                  <>
                    <Field
                      label="Date of hire"
                      isRequired
                      name={fields.dateOfHire}
                      options={toOptionValuesFromMapper(
                        OPTIONS_DATA_MAPPER.DATE_OF_HIRE
                      )}
                      value={values[fields.dateOfHire]}
                      selectedValue={values[fields.dateOfHire]}
                      component={FieldButtonGroup}
                      onChange={(value) => {
                        setFieldValue(fields.dateOfHire, value);
                        onDateOfHireChange(value);
                      }}
                      validate={(value) => {
                        return [undefined, null, ""].includes(value)
                          ? "PL804 : Required"
                          : undefined;
                      }}
                      disabled={isEdit && !isSave}
                      size="smd"
                    />
                    {values[fields.dateOfHire] === 1 ? (
                      <Field
                        label="Hired on or after date"
                        isRequired
                        name={fields.hiredOnOrAfterDateAdditionalEnrollment}
                        isDatePicker
                        // {...rest}
                        value={usDateFormat(
                          values[fields.hiredOnOrAfterDateAdditionalEnrollment]
                        )}
                        selectedValue={
                          values[fields.hiredOnOrAfterDateAdditionalEnrollment]
                        }
                        component={FieldDropSide}
                        onClear={() =>
                          setFieldValue(
                            fields.hiredOnOrAfterDateAdditionalEnrollment,
                            ""
                          )
                        }
                        disabled={isEdit && !isSave}
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(
                                fields.hiredOnOrAfterDateAdditionalEnrollment,
                                value
                              )
                            }
                            value={usDateFormat(
                              values[
                                fields.hiredOnOrAfterDateAdditionalEnrollment
                              ]
                            )}
                          />
                        }
                        validate={(value) => {
                          return [undefined, null, ""].includes(value)
                            ? "PL805 : Required"
                            : undefined;
                        }}
                      />
                    ) : null}

                    {values[fields.dateOfHire] === 2 ? (
                      <Field
                        label="Hired on or before date"
                        name={fields.hiredOnOrBeforeDateAdditionalEnrollment}
                        isDatePicker
                        isRequired
                        // {...rest}
                        value={usDateFormat(
                          values[fields.hiredOnOrBeforeDateAdditionalEnrollment]
                        )}
                        selectedValue={
                          values[fields.hiredOnOrBeforeDateAdditionalEnrollment]
                        }
                        component={FieldDropSide}
                        onClear={() =>
                          setFieldValue(
                            fields.hiredOnOrBeforeDateAdditionalEnrollment,
                            ""
                          )
                        }
                        disabled={isEdit && !isSave}
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(
                                fields.hiredOnOrBeforeDateAdditionalEnrollment,
                                value
                              )
                            }
                            value={usDateFormat(
                              values[
                                fields.hiredOnOrBeforeDateAdditionalEnrollment
                              ]
                            )}
                          />
                        }
                        validate={(value) => {
                          return [undefined, null, ""].includes(value)
                            ? "PL806 : Required"
                            : undefined;
                        }}
                      />
                    ) : null}

                    {values[fields.dateOfHire] === 3 ? (
                      <>
                        <p className="font-weight-500 text-black">
                          Hired Between(Inclusive)
                        </p>
                        <Row>
                          <Col md="4">
                            <Field
                              label="From"
                              name={fields.hiredBetweenFrom}
                              isRequired
                              isDatePicker
                              size="md"
                              // {...rest}
                              value={usDateFormat(
                                values[fields.hiredBetweenFrom]
                              )}
                              selectedValue={values[fields.hiredBetweenFrom]}
                              component={FieldDropSide}
                              onClear={() =>
                                setFieldValue(fields.hiredBetweenFrom, "")
                              }
                              disabled={isEdit && !isSave}
                              validate={(value) => {
                                return [undefined, null, ""].includes(value)
                                  ? "PL807 : Required"
                                  : undefined;
                              }}
                              popupContent={
                                <DatePicker
                                  onDayClick={(value) =>
                                    onDaySelected(
                                      fields.hiredBetweenFrom,
                                      value
                                    )
                                  }
                                  value={usDateFormat(
                                    values[fields.hiredBetweenFrom]
                                  )}
                                />
                              }
                            />
                          </Col>
                          <Col>
                            <Field
                              label="To"
                              isRequired
                              name={fields.hiredBetweenTo}
                              isDatePicker
                              size="md"
                              // {...rest}
                              value={usDateFormat(
                                values[fields.hiredBetweenTo]
                              )}
                              selectedValue={values[fields.hiredBetweenTo]}
                              component={FieldDropSide}
                              onClear={() =>
                                setFieldValue(fields.hiredBetweenTo, "")
                              }
                              disabled={isEdit && !isSave}
                              popupContent={
                                <DatePicker
                                  onDayClick={(value) =>
                                    onDaySelected(fields.hiredBetweenTo, value)
                                  }
                                  value={usDateFormat(
                                    values[fields.hiredBetweenTo]
                                  )}
                                />
                              }
                              validate={(value) => {
                                return [undefined, null, ""].includes(value)
                                  ? "PL808 : Required"
                                  : values[fields.hiredBetweenTo] <
                                    values[fields.hiredBetweenFrom]
                                  ? "PL809 : From date should not be greater than to date"
                                  : undefined;
                              }}
                            />
                          </Col>
                        </Row>
                      </>
                    ) : null}
                  </>
                ) : null}

                {values[fields.exclusionType] === 3 ? (
                  <>
                    <Field
                      size="md"
                      isRequired
                      label="Excluded Employee Classifications"
                      options={excludedEmployeeClassifications}
                      name={fields.excludedEmployeeClassifications}
                      value={toMultiSelectValueById(
                        selectedExcludedEmployeeClassifications,
                        excludedEmployeeClassifications
                      )}
                      disabled={isEdit && !isSave}
                      isMultiSelect
                      popupContent={
                        <MultiSelectDropdown
                          label="Select an Employee Classifications"
                          options={excludedEmployeeClassifications}
                          onSelect={(value) =>
                            setFieldValue(
                              fields.excludedEmployeeClassifications,
                              value
                            )
                          }
                          name={fields.excludedEmployeeClassifications}
                          value={values[fields.excludedEmployeeClassifications]}
                          disabled={isEdit && !isSave}
                          validate={(value) => {
                            return [undefined, null, ""].includes(value)
                              ? "PL810 : Required"
                              : undefined;
                          }}
                        />
                      }
                      component={FieldDropSide}
                    />

                    <Field
                      label="Date of hire"
                      isRequired
                      name={fields.dateOfHire}
                      options={toOptionValuesFromMapper(
                        OPTIONS_DATA_MAPPER.DATE_OF_HIRE
                      )}
                      value={values[fields.dateOfHire]}
                      selectedValue={values[fields.dateOfHire]}
                      component={FieldButtonGroup}
                      onChange={(value) => {
                        setFieldValue(fields.dateOfHire, value);
                        onDateOfHireChange(value);
                      }}
                      disabled={isEdit && !isSave}
                      size="smd"
                    />

                    {values[fields.dateOfHire] === 1 ? (
                      <Field
                        label="Hired on or after date"
                        isRequired
                        name={fields.hiredOnOrAfterDateAdditionalEnrollment}
                        isDatePicker
                        {...rest}
                        value={usDateFormat(
                          values[fields.hiredOnOrAfterDateAdditionalEnrollment]
                        )}
                        selectedValue={
                          values[fields.hiredOnOrAfterDateAdditionalEnrollment]
                        }
                        component={FieldDropSide}
                        onClear={() =>
                          setFieldValue(
                            fields.hiredOnOrAfterDateAdditionalEnrollment,
                            ""
                          )
                        }
                        disabled={isEdit && !isSave}
                        validate={(value) => {
                          return [undefined, null, ""].includes(value)
                            ? "PL811 : Required"
                            : undefined;
                        }}
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(
                                fields.hiredOnOrAfterDateAdditionalEnrollment,
                                value
                              )
                            }
                            value={usDateFormat(
                              values[
                                fields.hiredOnOrAfterDateAdditionalEnrollment
                              ]
                            )}
                          />
                        }
                      />
                    ) : null}

                    {values[fields.dateOfHire] === 2 ? (
                      <Field
                        label="Hired on or before date"
                        isRequired
                        name={fields.hiredOnOrBeforeDateAdditionalEnrollment}
                        isDatePicker
                        {...rest}
                        value={usDateFormat(
                          values[fields.hiredOnOrBeforeDateAdditionalEnrollment]
                        )}
                        selectedValue={
                          values[fields.hiredOnOrBeforeDateAdditionalEnrollment]
                        }
                        component={FieldDropSide}
                        onClear={() =>
                          setFieldValue(
                            fields.hiredOnOrBeforeDateAdditionalEnrollment,
                            ""
                          )
                        }
                        disabled={isEdit && !isSave}
                        validate={(value) => {
                          return [undefined, null, ""].includes(value)
                            ? "PL812 : Required"
                            : undefined;
                        }}
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(
                                fields.hiredOnOrBeforeDateAdditionalEnrollment,
                                value
                              )
                            }
                            value={usDateFormat(
                              values[
                                fields.hiredOnOrBeforeDateAdditionalEnrollment
                              ]
                            )}
                          />
                        }
                      />
                    ) : null}

                    {values[fields.dateOfHire] === 3 ? (
                      <>
                        <p className="font-weight-500 text-black">
                          Hired Between(Inclusive)
                        </p>
                        <Row>
                          <Col md="4">
                            <Field
                              label="From"
                              name={fields.hiredBetweenFrom}
                              isRequired
                              isDatePicker
                              size="md"
                              // {...rest}
                              value={usDateFormat(
                                values[fields.hiredBetweenFrom]
                              )}
                              selectedValue={values[fields.hiredBetweenFrom]}
                              component={FieldDropSide}
                              onClear={() =>
                                setFieldValue(fields.hiredBetweenFrom, "")
                              }
                              disabled={isEdit && !isSave}
                              popupContent={
                                <DatePicker
                                  onDayClick={(value) =>
                                    onDaySelected(
                                      fields.hiredBetweenFrom,
                                      value
                                    )
                                  }
                                  value={usDateFormat(
                                    values[fields.hiredBetweenFrom]
                                  )}
                                />
                              }
                              validate={(value) => {
                                return [undefined, null, ""].includes(value)
                                  ? "PL813 : Required"
                                  : undefined;
                              }}
                            />
                          </Col>
                          <Col>
                            <Field
                              label="To"
                              isRequired
                              name={fields.hiredBetweenTo}
                              isDatePicker
                              size="md"
                              // {...rest}
                              value={usDateFormat(
                                values[fields.hiredBetweenTo]
                              )}
                              selectedValue={values[fields.hiredBetweenTo]}
                              component={FieldDropSide}
                              onClear={() =>
                                setFieldValue(fields.hiredBetweenTo, "")
                              }
                              disabled={isEdit && !isSave}
                              popupContent={
                                <DatePicker
                                  onDayClick={(value) =>
                                    onDaySelected(fields.hiredBetweenTo, value)
                                  }
                                  value={usDateFormat(
                                    values[fields.hiredBetweenTo]
                                  )}
                                />
                              }
                              validate={(value) => {
                                return [undefined, null, ""].includes(value)
                                  ? "PL814 : Required"
                                  : values[fields.hiredBetweenTo] <
                                    values[fields.hiredBetweenFrom]
                                  ? "PL815 : From date should not be greater than to date"
                                  : undefined;
                              }}
                            />
                          </Col>
                        </Row>
                      </>
                    ) : null}
                  </>
                ) : null}

                <Field
                  size="md"
                  label="Excluded Employment Status"
                  options={excludedEmploymentStatuses}
                  name={fields.excludedEmploymentStatuses}
                  value={toMultiSelectValueById(
                    selectedexcludedEmploymentStatuses,
                    excludedEmploymentStatuses
                  )}
                  disabled={isEdit && !isSave}
                  isMultiSelect
                  popupContent={
                    <MultiSelectDropdown
                      label="Select as Employment Status"
                      options={excludedEmploymentStatuses}
                      onSelect={(value) =>
                        setFieldValue(fields.excludedEmploymentStatuses, value)
                      }
                      selectedOptions={fields.excludedEmploymentStatuses}
                      name={fields.excludedEmploymentStatuses}
                      value={values[fields.excludedEmploymentStatuses]}
                      disabled={isEdit && !isSave}
                    />
                  }
                  // validate={required}
                  component={FieldDropSide}
                />

                <Row>
                  <Col>
                    <p className="font-weight-500 text-black">
                      Deferral Election
                    </p>
                    <Field
                      isRequired
                      name={fields.usePlanDefaultDeferralElection}
                      label="Use plan default deferral election"
                      size="sm"
                      options={yesNoOptions}
                      selectedValue={returnOnlyIfBoolean(
                        values[fields.usePlanDefaultDeferralElection]
                      )}
                      onChange={(value) => {
                        setFieldValue(
                          fields.usePlanDefaultDeferralElection,
                          value
                        );
                        if (!value) {
                          transformedDeferralSourceList?.map((e, i) => {
                            setFieldValue(
                              `additionalAutoEnrollmentDeferralSources[${i}].deferralSourcePercentage`,
                              null
                            );
                          });
                        }
                      }}
                      disabled={isEdit && !isSave}
                      component={FieldButtonGroup}
                      validate={(value) => {
                        return [undefined, null, ""].includes(value)
                          ? "PL816 : Required"
                          : undefined;
                      }}
                    />
                    <p
                      style={{ fontSize: "14px" }}
                      className="font-weight-500 text-black"
                    >
                      Contribution percentage/amount
                    </p>
                    {values[fields.usePlanDefaultDeferralElection] === false ? (
                      <FieldArray name="sourceList">
                        <Table.Tbody>
                          {transformedDeferralSourceList &&
                            transformedDeferralSourceList.map((e, i) => {
                              const fieldName = `additionalAutoEnrollmentDeferralSources[${i}].deferralSourcePercentage`;
                              const checkBoxName = `additionalAutoEnrollmentDeferralSources[${i}].excludeFromEnrollment`;
                              //const sourceName= `additionalAutoEnrollmentDeferralSources[${i}].deferralSourceName`;
                              const AddName = (
                                e,
                                source,
                                sourceId,
                                limitMaximumDollar,
                                limitMinimumDollar
                              ) => {
                                if (
                                  !isEmpty(
                                    values
                                      .additionalAutoEnrollmentDeferralSources[
                                      i
                                    ]
                                  )
                                ) {
                                  //values.additionalAutoEnrollmentDeferralSources=values.additionalAutoEnrollmentDeferralSources.map(obj=> ({ ...obj[i], deferralSourceName:source }))
                                  values.additionalAutoEnrollmentDeferralSources[
                                    i
                                  ].deferralSourceName = source;
                                  values.additionalAutoEnrollmentDeferralSources[
                                    i
                                  ].sourceId = sourceId;
                                  values.additionalAutoEnrollmentDeferralSources[
                                    i
                                  ].limitMaximumDollar = limitMaximumDollar;
                                  values.additionalAutoEnrollmentDeferralSources[
                                    i
                                  ].limitMinimumDollar = limitMinimumDollar;
                                }
                                handleChange(e);
                              };

                              return (
                                <div key={i} className="d-flex">
                                  <Field
                                    size="xs"
                                    isRequired
                                    name={fieldName}
                                    label={e.sourceName}
                                    hasSuggestion
                                    suggestionDefaultText={`${displayType(
                                      e.minimumRate,
                                      e.contributionType,
                                      0
                                    )} / ${displayType(
                                      e.maximumRate,
                                      e.contributionType,
                                      1
                                    )}`}
                                    shouldDisplaySuggestion
                                    component={
                                      e.contributionType === 2
                                        ? FieldInputDollar
                                        : FieldInputPercentage
                                    }
                                    type="number"
                                    max={100}
                                    autoComplete="off"
                                    defaultValue={parseInt(
                                      get(values, fieldName)
                                    )}
                                    onChange={(x) => {
                                      AddName(
                                        x,
                                        e.sourceName,
                                        e.sourceId,
                                        e.maximumRate,
                                        e.minimumRate
                                      );
                                    }}
                                    disabled={
                                      (isEdit && !isSave) ||
                                      get(
                                        values,
                                        `additionalAutoEnrollmentDeferralSources[${i}].excludeFromEnrollment`
                                      )
                                    }
                                    validate={(value) => {
                                      return [undefined, null, ""].includes(
                                        value
                                      )
                                        ? "PL817 : Required"
                                        : value > e.maximumRate ||
                                          value < e.minimumRate
                                        ? `PL818 : Input should be between minimum and maximum ${
                                            e.contributionType == 1
                                              ? "percentage"
                                              : "dollar"
                                          }`
                                        : undefined;
                                    }}
                                  />
                                  &nbsp;&nbsp;&nbsp;
                                  <div
                                    style={{
                                      marginLeft: "2rem",
                                    }}
                                  ></div>
                                  <Form.Check
                                    custom
                                    name={checkBoxName}
                                    type="checkbox"
                                    id={checkBoxName}
                                    value={get(values, checkBoxName)}
                                    onChange={handleChange}
                                    checked={get(values, checkBoxName)}
                                    disabled={isEdit && !isSave}
                                  />
                                  &nbsp;&nbsp;&nbsp;
                                  <div
                                    style={{
                                      //marginBottom: "-4rem",
                                      fontSize: "13px",
                                      paddingTop: "40px",
                                    }}
                                    //size="xs"
                                  >
                                    Exclude from Enrollment
                                  </div>
                                </div>
                              );
                            })}
                        </Table.Tbody>
                      </FieldArray>
                    ) : null}
                    {values[fields.usePlanDefaultDeferralElection] === true ? (
                      <FieldArray name="getDefaultElection">
                        {(fieldArrayProps) => (
                          <>
                            {!isEmpty(
                              getDefaultElection.deferralSourceContribution
                            ) &&
                              get(
                                getDefaultElection,
                                "deferralSourceContribution",
                                []
                              ).map((e, i) => {
                                return (
                                  <div key={i}>
                                    <Field
                                      size="xs"
                                      isRequired
                                      name={e?.sourceName}
                                      label={e?.sourceName}
                                      value={e?.contributionRate}
                                      disabled={true}
                                      component={
                                        get(e, "contributionType", 1) === 2
                                          ? FieldInputDollar
                                          : FieldInputPercentage
                                      }
                                      type="number"
                                      autoComplete="off"
                                    />
                                  </div>
                                );
                              })}
                          </>
                        )}
                      </FieldArray>
                    ) : null}
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <p className="font-weight-500 text-black">
                      Investment Election
                    </p>
                    <div>
                      <InvestmentElectionFields
                        {...formProps}
                        fields={fields}
                        isEdit={isEdit}
                        isSave={isSave}
                        sourcesList={sourcesList}
                        investmentList={investmentList}
                        getDefaultElection={getDefaultElection}
                        initialValues={initialValues}
                        setToggle={setToggle}
                        toggle={toggle}
                        additionalAutoEnrollmentData={
                          AdditionalAutoEnrollmentData
                        }
                        planId={planId}
                        invetmentElectionError={invetmentElectionError}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
              <DeleteWarning
                DeleteToastMessageHead={DeleteToastMessageHead}
                DeleteToastMessage={DeleteToastMessage}
                showModal={showWarning}
                handleConfirmClick={deleteAdditionalAutoEnrollment}
                handleCancelClick={handleCancelClick}
              />
              ;
            </ManagePlanLayout>
          </Form>
        );
      }}
    </Formik>
  );
};

export default AdditionalAutoEnrollmentContainer;
